import { FC, PropsWithChildren, useCallback } from 'react';

import { ContentCard } from '@braze/react-native-sdk';

import { useBrazeContext } from 'state/braze';
import { ContentCardTypes } from 'state/braze/types';

import {
  ButtonContainer,
  CardButton,
  CardDescription,
  CardTitle,
  ClassicCardContainer,
  ClassicCardContent,
  ClassicCardImage,
  ContentCardContainer,
} from './styled';
import { useContentCardNavigation } from './use-content-card-navigation';

type ClassicContentCardProps = {
  card: ContentCard & {
    type: typeof ContentCardTypes.CLASSIC;
  };
  isUnread: boolean;
};

export const ClassicContentCard: FC<PropsWithChildren<ClassicContentCardProps>> = ({
  card,
  isUnread,
}) => {
  const { logContentCardClicked } = useBrazeContext();
  const { navigate } = useContentCardNavigation();

  const handleClickCta = useCallback(() => {
    logContentCardClicked(card, true, { isUnread });
    !!card.url && navigate({ url: card.url });
  }, [card, isUnread, logContentCardClicked, navigate]);

  return (
    <ContentCardContainer>
      <ClassicCardContainer>
        {card.image && (
          <ClassicCardImage
            alt={card.title}
            source={{ uri: card.image }}
            style={{ aspectRatio: 1 }}
          />
        )}
        <ClassicCardContent>
          <CardTitle>{card.title}</CardTitle>
          <CardDescription>{card.cardDescription}</CardDescription>
          <ButtonContainer>
            {!!card.url && <CardButton onPress={handleClickCta}>{card.domain}</CardButton>}
          </ButtonContainer>
        </ClassicCardContent>
      </ClassicCardContainer>
    </ContentCardContainer>
  );
};
